import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ModalDialogService } from 'ngx-modal-dialog';
import { CancelModalComponent } from '../modal-cancel-component/modal-cancel-component';
import { authenticaitonModel } from '../authentication/model/authenticaiton.model';
import { CancelErroModalComponent } from '../modal-cancel-component-error/modal-cancel-component-error';
import { headersBase } from '../../../helper/headerBase';
import { ModalComponent } from '../modal-component/modal-component';

@Component({
  selector: 'app-pix-payment-component',
  templateUrl: './pix-payment.component.html',
  styleUrls: ['./pix-payment.component.css']
})

export class PixPaymentComponent implements OnInit {
  public pixPayments: PixPaymentController[];
  public logs: LogPaymentController[];
  public pixPayment: object;
  public log: object;
  public pageSize: number = 5;
  public p: number = 1;
  public total: number = 40;
  public txtSearch: string = "*";
  public modalService: ModalDialogService;
  public viewRef: ViewContainerRef;
  public loading: boolean;
  public originSelected: string = null;
  public periodSelected: string = '30';
  public integrationErroSelected: string = null;
  public logError: boolean = false;
  currentUser: authenticaitonModel = null;

  constructor(modalService: ModalDialogService, viewRef: ViewContainerRef, private _http: HttpClient) {
    this.modalService = modalService;
    this.viewRef = viewRef;

  }

  public openNewDialog() {
    this.modalService.openDialog(this.viewRef, {
      title: 'Confirmação de cancelamento',
      settings: { headerClass: "modal-header HeaderModalCancel", },
      childComponent: CancelModalComponent,

      actionButtons: [
        { text: 'Fechar' }, //  nenhum processamento especial aqui
        { text: 'Cancelar pagamento', onAction: () => this.cancelPayment(), buttonClass: "btn btn-outline btnCancelPayment" },
        // { text: 'Eu nunca fecho', onAction: () => false },
      ]
    });
  }

  public doSearch($event: Event) {
    this.p = 1;
    this.txtSearch = ($event.target as HTMLInputElement).value;
    this.getPixPayments(this.p);
  }

  public doSearchClear() {
    this.p = 1;
    this.txtSearch = "*";
    this.getPixPayments(this.p);
  }

  public refrehPage() {
    this.getPixPayments(this.p);
  }

  public getPixPayments(page) {
    this.loading = true;
    page = page == 0 ? 1 : page;
    let url = `/Pix/getpayments/${page}/${this.txtSearch}?`;
    if (this.originSelected != null) {
      url = `${url}origin=${this.originSelected}`
    } else {
      url = `${url}origin=`
    }
    if (this.periodSelected != null)
      url = `${url}&period=${this.periodSelected}`;
    else
      url = `${url}&period=0`;

    if (this.integrationErroSelected != null) {
      url = `${url}&integrationErro=${this.integrationErroSelected}`
    } else {
      url = `${url}&integrationErro=`
    }
    return this._http.get<PixPaymentController[]>(url, headersBase()).subscribe(result => {
      this.loading = false;
      this.pixPayments = result["listPix"];
      if (result["listPix"]) {
        this.pixPayment = result["listPix"][0];
      } else {
        this.pixPayment = {};
      }
      this.pageSize = result["pageSize"];
      this.p = result["currentPage"];
      this.total = result["totalRecords"];
    });
  }

  public displayLog(id) {
    if (document.getElementById(id).style.display == "block") {
      document.getElementById(id).style.display = "none";
    }

    else {
      document.getElementById(id).style.display = "block";
    }
  }

  public getLogs(paymentId, logTable) {
    this.logs = [];
    this.logError = false;
    return this._http.get<LogPaymentController[]>("/" + "Log/" + paymentId + `/get${logTable}logsbypaymentId`, headersBase()).subscribe(result => {

      for (var i in result) {
        try {
          result[i]["message"] = JSON.stringify(JSON.parse(result[i]["message"]), null, 2);
        } catch (e) { }
      }
      
      if (result && result.length > 0) {
        this.logs = result;
      }
      else {
        //this.toastr.error('Não foi possível buscar os pagamentos!', 'Atenção');
        this.logError = true;
      }
    });
  }

  public setPixPayment(index) {
    this.pixPayment = this.pixPayments[index];
    this.pixPayment["classStatus"] = "hidden";
    if (this.pixPayment["paymentCaptured"]) {
      this.pixPayment["classStatus"] = "cardCapturedTransaction";
      this.pixPayment["textStatus"] = "Este pagamento está capturado";
      this.pixPayment["classButtonCapture"] = "hidden";
    }
    if (this.pixPayment["canceled"]) {
      this.pixPayment["classStatus"] = "cardCanceledTransaction";
      this.pixPayment["textStatus"] = "Este pagamento está cancelado";
      this.pixPayment["classButtonCancel"] = "hidden";
      this.pixPayment["classButtonCapture"] = "hidden";
    }
  }

  public openModal(modal, index) {
    document.getElementById(modal).style.display = "block";
    document.getElementById(modal).style.backgroundColor = "rgba(12, 0, 0, 0.5)";

    this.setPixPayment(index);
    this.logError = false;
    this.getLogs(this.pixPayment["id"], '');
  }

  public closeModal(modal) {
    document.getElementById(modal).style.display = "none";
    //this.loading = false;
  }

  public cancelPayment() {
    this._http.delete<PixPaymentController[]>("/" + "Pix/" + this.pixPayment["id"] + "/cancelpaymentdebitcard", headersBase()).subscribe(result => {
      if (result["status"] == "voided") {
        /////this.toastr.success('Pagamento cancelado com sucesso!', 'Mensagem');
      }
      else {
        ///////this.toastr.error('Não foi possível cancelar os pagamentos!', 'Atenção');
      }
      this.getPixPayments(this.p);
      this.closeModal('modalDetailPaymentPix');
      //window.location.reload();
    });
    return true;

  }

  public capturePayment() {
    return this._http.get<PixPaymentController[]>("/" + "Pix/" + this.pixPayment["id"] + "/capturepaymentdebitcard", headersBase()).subscribe(result => {
      if (result["status"] == "payment-confirmed") {
        //this.toastr.info('Pagamento capturado com sucesso!', 'Mensagem');
      }
      else {
        //this.toastr.error('Não foi possível capturado os pagamentos!', 'Atenção');
      }
      window.location.reload();

    });
  }

  public RecoverPayment() {
    this.loading = true;
    this._http.put<PixPaymentController[]>("/pix/RecoveryPayments/" + this.pixPayment["id"], null, headersBase()).subscribe(result => {
      this.loading = false; 
      if (result["error"] != undefined) {
        this.modalService.openDialog(this.viewRef, {
          title: 'Erro durante o processo de recuperação',
          settings: { headerClass: "modal-header HeaderModalCancel", },
          childComponent: CancelErroModalComponent,
          actionButtons: [
            { text: 'Fechar', onAction: () => { this.getLogs(this.pixPayment["id"], ''); return true; } },
          ]
        });
      } else {
        this.modalService.openDialog(this.viewRef, {
          title: 'Recuperação do pagamento',
          childComponent: ModalComponent,
          data: { message: "Processo concluido com sucesso" },
          settings: { headerClass: "modal-header HeaderModalSuccess", },
          actionButtons: [
            { text: 'Fechar', onAction: () => { this.refrehPage(); this.closeModal("modalDetailPaymentPix"); return true; }, buttonClass: "btn btn-outline btnCancelPayment" },
          ]
        });
      }
    });
  }

  public sendConfirmToAx() {
    this.loading = true;
    this._http.put<PixPaymentController[]>("/order/ResendConfirmPaymentToAx/" + this.pixPayment["orderId"], null, headersBase()).subscribe(result => {
      this.loading = false; 
      if (result["error"] != undefined) {
        this.modalService.openDialog(this.viewRef, {
          title: 'Erro na integração do pagamento',
          settings: { headerClass: "modal-header HeaderModalCancel", },
          childComponent: CancelErroModalComponent,
          actionButtons: [
            { text: 'Fechar', onAction: () => { this.getLogs(this.pixPayment["id"], ''); return true; } },
          ]
        });
      } else {
        this.modalService.openDialog(this.viewRef, {
          title: 'Pagamento integrado com sucesso',
          settings: { headerClass: "modal-header HeaderModalSuccess", },
          actionButtons: [
            { text: 'Fechar', onAction: () => { this.refrehPage(); this.closeModal("modalDetailPaymentPix"); return true; }, buttonClass: "btn btn-outline btnCancelPayment" },
          ]
        });
      }
    });
  }

  public pageChanged(event) {
    this.getPixPayments(event);
  }

  public changeOrigin(origin: string) {
    this.originSelected = origin;
    this.p = 0;
    this.getPixPayments(this.p);
  }

  public changePeriod(period: string) {
    this.periodSelected = period;
    this.p = 0;
    this.getPixPayments(this.p);
  }

  public changeIntegrationErro(integrationErro: string) {
    this.integrationErroSelected = integrationErro;
    this.p = 0;
    this.getPixPayments(this.p);
  }

  ngOnInit() {
    if (!this.loggedUser()) {
      window.location.href = "/authentication";
    }

    this.getPixPayments(1);
  }

  loggedUser() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser && this.currentUser.userPermission) {
      return true;
    }
  }
}

interface PixPaymentController { }

interface LogPaymentController { }
